import gql from 'graphql-tag';
import { ChatFragment } from '../useGetLastDocumentChat';
export const MUTATION = gql `
  mutation AssistantChatAsync(
    $documentId: ID!
    $selection: String
    $type: DocumentChatMessageType
    $chatId: UUID
    $message: String
  ) {
    lastChat: documentAssistantChatAsync(
      input: {
        documentId: $documentId
        selection: $selection
        type: $type
        documentChatId: $chatId
        message: $message
      }
    ) {
      ...ChatFragment
    }
  }
  ${ChatFragment}
`;
